/**
 * Converts a glob pattern string to a regular expression
 * @param {string} glob The glob pattern to convert (e.g. "foo*.js")
 * @returns {RegExp} A regular expression that matches the same patterns as the glob
 * @example
 *
 *   globToRegex("foo*.js")
 *   // returns /^foo.*\.js$/
 *
 *   globToRegex("bar?.txt")
 *   // returns /^bar.\.txt$/
 */
export function globToRegex(glob: string): RegExp {
  // Escape special regex characters except * and ?
  const escaped = glob.replace(/[.+^${}()|[\]\\]/g, "\\$&");

  // Convert glob * to regex .*
  const converted = escaped.replace(/\*/g, ".*");

  // Convert glob ? to regex .
  const final = converted.replace(/\?/g, ".");

  return new RegExp(`^${final}$`);
}
